import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/temp-transactions';
const URL = BASE_URL + '/temp-transactions';

const getTempTransactionList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createTempTransaction = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
    // console.log(data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the transactions.');
    }
  }
};

const deleteTempTransaction = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getTempTransactionById = async (id) => {
  try {
    const response = await axios.get(`${URL}/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const approveTempTransactionByRreferensi = async (rreferensi) => {
  try {
    const response = await axios.post(`${URL}/approve`, { rreferensi });

    console.log(response.data.message);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the transactions.');
    }
  }
};

const updateTempTransaction = async (id, data) => {
  try {
    // console.log(data);
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the temp transaction.');
    }
  }
};

export {
  getTempTransactionList,
  createTempTransaction,
  deleteTempTransaction,
  getTempTransactionById,
  approveTempTransactionByRreferensi,
  updateTempTransaction,
};
